// extracted by mini-css-extract-plugin
export default {"container":"CustomSwitch_container__O247C","text":"CustomSwitch_text__QNnsa"};